/*
  - - - - - - - - - - - - - - - - - - - - - - -
  Support Pageable actions for the store.
  Wraps HTTP module and supports setting the result and firing notifications
  - - - - - - - - - - - - - - - - - - - - - - -
*/

const shareableResource = {
  state: {
  },
  mutations: {
  },
  getters: {
    canViewResource: (state, getters) => resource => getters.canPerformAction(resource, 'viewer'),
    canEditResource: (state, getters) => resource => getters.canPerformAction(resource, 'editor'),
    canPerformAction: (state, getters, rootState, rootGetters) => (resource, permission) => {
      const user = rootGetters['user/user'];

      // user is a super admin
      if (rootGetters['roles/userHasRole']('super-admin')) {
        return true;
      }

      // everyone permission is set on the resource
      if (resource.everyone_permission?.slug === permission) {
        return true;
      }

      // user has permission via user
      if (resource.sharing?.users?.find(resourcePermission => resourcePermission.permission.slug === permission && resourcePermission.user.id === user.id)) {
        return true;
      }

      // user has permission via groups
      if (resource.sharing?.groups?.find(resourcePermission => resourcePermission.permission.slug === permission && user.groups.find(group => group.id === resourcePermission.group.id))) {
          return true;
      }

      return false;
    },
  },
  actions: {
  },
};

export default shareableResource;
